<template>
 <div class="main-content">
     <breadcrumb :nameSection = 'nameSection' :listRoutes = 'listRoutes'></breadcrumb>
     <div class="form-content">
         <div class="form-content-title">

        <div class="form-content-title-block form-title">

          <div class="form-title-block form-title-principal">

            <span>Editar Rebate Seleccionado</span>

                </div>
            </div>
            <div class="form-group">
            <label for="" class="float-left">ID: {{this.id}}</label> 
                </div>
            <div class="form-group">
            <label >Amount:</label> 
                  <div class="input-group">
                  <input type="number" aria-describedby="nameUSer" class="form-control null" v-model="amountRebate" >
                </div>
                </div>
            <div class="form-group">
            <label >Codigo de Publicación:</label> 
            <div class="input-group">
                  <input type="text" aria-describedby="nameUSer" class="form-control null" v-model="publicationCode"> 
            </div>
            </div> 
            <div class="form-group">
        <label >Intervalo de Fecha </label> 
            <div class="input-group">
        <input
        id="date"
          type="date"
          class='form-control login__input sen-form-input-with-tooltip'
          placeholder="To"
          onkeydown="return false"
          required
          v-model="dateTo"
        >
        <input
        id="date2"
          type="date"
          class='form-control login__input sen-form-input-with-tooltip ' 
          placeholder="From"
          onkeydown="return false"
          required
          v-model="datefrom"
        >
            </div>
        </div>
        <div class="form-group">
          <div class="text-right">
        <b-button  class="btn btn-primary" v-on:click="editRebate()"><i class="fas fa-edit"></i>Editar</b-button>
         <b-button  class="btn btn-secunday" v-on:click="deleteRebate()"><i class="fas fa-trash"></i>Eliminar</b-button>
        </div>
        </div>
          </div>
          
     </div>

 </div>
    
</template>
<script>
import breadcrumb from '@/components/prefab/structures/breadcrumb.vue'
import axios from 'axios'
export default {
    
  components: {  breadcrumb },
  created() {
    this.getRebate()
   
   
  },
  data() {
    return {
        id:this.$store.state.route.params.id,
        amountRebate:"",
        publicationCode:"",
        price:"",
        title:"",
        datefrom:"",
        dateTo:"",
        active:"",
        nameSection: 'Editar Rebate',
        listRoutes: [{ nameRoute: 'EditRebate', titleRoute: 'Editar Rebate' }]
    }
  },
  methods: {
    getRebate(){
      axios.get(process.env.API_URL+"/api/rebate/"+this.id+"/get")
    .then( response =>{
          console.log(response)
          var dateFrom=response.data.body.from.split(" ")
          dateFrom=dateFrom[0]
          var dateTo=response.data.body.to.split(" ")
          dateTo=dateTo[0]
          this.amountRebate=response.data.body.amount
          this.publicationCode=response.data.body.publication_code
          this.datefrom=dateFrom
          this.dateTo=dateTo
          this.active=response.data.body.active
    });
    },
    editRebate(){
      if($("#date").val() < $("#date2").val())
          {
            axios.post(process.env.API_URL+"/api/rebate/update",{
        "id":this.id,
        "amount":this.amountRebate,
        "publication_code":this.publicationCode,
        "from":this.datefrom,
        "to":this.dateTo,
      })
    .then( response =>{
          console.log(response)
          if (response.data.status) {
              window.history.go(-1)
            }
    });
          }else{
            alert("La fecha de inicio no puede ser menor que la de fin")
          }
      
    },
    deleteRebate(){
      axios.get(process.env.API_URL+"/api/rebate/delete/"+this.id)
    .then( response =>{
          console.log(response)
          if (response.data.status) {
              window.history.go(-1)
            }
    });
    }
  },
  computed: {
    

  }
}
</script>
<style lang="css" scoped>
</style>




// WEBPACK FOOTER //
// EditRebate.vue?28a4f86c